import VectorLayer from '@/models/vector-layer'
import vectorUtils from '@src/utils/vectorUtils'
import {LayerTypes} from '@models/layer'

export default class VectorTextLayer extends VectorLayer {
  constructor (obj, needMap) {
    super(obj, needMap)
    if (needMap) {
      this._type = 'symbol'
      let color = obj.color ? obj.color : vectorUtils.randomColor()
      this._paint = {
        'text-color': '#1f1e1e',
        'text-halo-blur': 0.2,
        'text-halo-color': '#1f1e1e',
        'text-halo-width': 1,
        'text-opacity': 1
      }
    } else {
      Object.assign(this, obj)
    }
  }

  get colorPreview () {
    return this._paint['text-color']
  }

  get mapboxOpacityKeys () {
    return ['text-opacity']
  }
}



// WEBPACK FOOTER //
// ./src/models/vector-text-layer.js